<!--
 * @Author: natsu
 * @Date: 2020-06-04 08:47:44
 * @LastEditors: natsu
 * @LastEditTime: 2021-04-27 14:50:05
 * @Description: file content
-->
<template>
  <div class="wrapper">
    <header class="bg">
      <h2>UED-CDN</h2>
      <div class="logo-page"><img src="../assets/images/zui.png" /></div>
      <p>zui-screw</p>
    </header>
    <section>
      <file-list :fileList="fileList"></file-list>
    </section>
  </div>
</template>

<script>
const ur = "https://uedcdn.zto.com/static/zui-screw/";
export default {
  name: "index",
  data() {
    return {
      fileList: [
        {
          label: "1.1.13",
          linkList: [
            ur + "1.1.13/zui-screw.zui.css",
            ur + "1.1.13/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.12",
          linkList: [
            ur + "1.1.12/zui-screw.zui.css",
            ur + "1.1.12/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.11",
          linkList: [
            ur + "1.1.11/zui-screw.zui.css",
            ur + "1.1.11/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.10",
          linkList: [
            ur + "1.1.10/zui-screw.zui.css",
            ur + "1.1.10/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.9",
          linkList: [
            ur + "1.1.9/zui-screw.zui.css",
            ur + "1.1.9/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.7",
          linkList: [
            ur + "1.1.7/zui-screw.zui.css",
            ur + "1.1.7/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.6-beta.1",
          linkList: [
            ur + "1.1.6-beta.1/zui-screw.zui.css",
            ur + "1.1.6-beta.1/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.5",
          linkList: [
            ur + "1.1.5/zui-screw.zui.css",
            ur + "1.1.5/zui-screw.min.js"
          ]
        },
        {
          label: "1.1.3",
          linkList: [
            ur + "1.1.3/zui-screw.zui.css",
            ur + "1.1.3/zui-screw.min.js"
          ]
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListZuiScrew.vue